import VehiclePausedDataAlert from './VehiclePausedDataAlert'
import UtilityProgramDashboardAlert from '@/app/features/utility-programs/UtilityProgramDashboardAlert'
import { ID } from '@/types/model'

type Props = {
  vehicleId: ID
}

export default function VehicleSectionHeader(props: Props) {
  return (
    <>
      <VehiclePausedDataAlert {...props} />
      <UtilityProgramDashboardAlert
        deviceId={props.vehicleId}
        deviceType="vehicle"
      />
    </>
  )
}
